import { Input, InputProps } from '@chakra-ui/react';

export default function DisplayInput(props: InputProps) {
  return <Input readOnly _readOnly={{ color: 'fontColor' }} _focus={{}} {...props} />;
}
